export default () =>
  ['development', 'demo', 'test', 'feqa-1', 'feqa-2', 'stage'].includes(
    import.meta.env.VITE_ENV,
  );
